import React, { forwardRef, useImperativeHandle, useRef } from "react";
import { Grid } from "@mui/material";

const StripeInput = forwardRef(
    ({ component: Component, onChange, ...props }, ref) => {
        const elementRef = useRef();

        useImperativeHandle(ref, () => ({
            focus: () => elementRef.current.focus()
        }));

        const handleChange = (event) => {
            if (onChange) {
                onChange(event);
            }
        };

        return (
            <Grid
                item
                {...props}
                container
                sx={{
                    position: "relative",
                    top: "1px"
                }}
            >
                <Component
                    options={{
                        style: {
                            base: {
                                fontSize: "14px",
                                letterSpacing: "0.025em",
                                "::placeholder": {
                                    color: "rgba(0,0,0,0.6)"
                                }
                            },
                            invalid: {
                                color: "#c23d4b"
                            }
                        }
                    }}
                    onChange={handleChange}
                    onReady={(element) => (elementRef.current = element)}
                />
            </Grid>
        );
    }
);

export default StripeInput;
